import(/* webpackMode: "eager", webpackExports: ["AfricanAdvantageSection"] */ "/codebuild/output/src3297588696/src/octohealth-web/components/african-advantage-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoSection"] */ "/codebuild/output/src3297588696/src/octohealth-web/components/demo-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/codebuild/output/src3297588696/src/octohealth-web/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/codebuild/output/src3297588696/src/octohealth-web/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/codebuild/output/src3297588696/src/octohealth-web/components/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProblemSolutionSection"] */ "/codebuild/output/src3297588696/src/octohealth-web/components/problem-solution-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductFeaturesSection"] */ "/codebuild/output/src3297588696/src/octohealth-web/components/product-features-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustedBySection"] */ "/codebuild/output/src3297588696/src/octohealth-web/components/trusted-by-section.tsx");
